const BookViaWhatsAppIcon = ({ className = '' }) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_16678_514)">
        <path
          d="M13.3971 29.6312C13.3961 32.9214 14.2559 36.1342 15.8906 38.9658L13.2407 48.641L23.142 46.0448C25.8697 47.5316 28.9412 48.3164 32.067 48.3172H32.0752C42.3686 48.3172 50.7477 39.941 50.752 29.6459C50.754 24.6571 48.8129 19.966 45.2864 16.4367C41.7605 12.9077 37.071 10.9631 32.0745 10.9609C21.7799 10.9609 13.4015 19.3365 13.3971 29.6312Z"
          fill="url(#paint0_linear_16678_514)"
        />
        <path
          d="M12.7314 29.6241C12.7302 33.0328 13.6208 36.3604 15.3137 39.2934L12.5688 49.3154L22.8252 46.6262C25.6511 48.1671 28.8328 48.9794 32.0705 48.9806H32.0788C42.7414 48.9806 51.4215 40.3033 51.426 29.6397C51.4278 24.4715 49.4169 19.6119 45.7645 15.9561C42.1114 12.3007 37.2542 10.2863 32.0788 10.2842C21.4142 10.2842 12.7357 18.9601 12.7314 29.6241ZM18.8391 38.7884L18.4562 38.1805C16.8463 35.6207 15.9966 32.6627 15.9978 29.6253C16.0013 20.7619 23.2147 13.5508 32.0849 13.5508C36.3803 13.5526 40.4173 15.227 43.4536 18.2653C46.4898 21.3037 48.1605 25.3427 48.1594 29.6385C48.1554 38.5021 40.9418 45.7141 32.0788 45.7141H32.0725C29.1865 45.7126 26.3563 44.9376 23.8878 43.4731L23.3003 43.1247L17.214 44.7204L18.8391 38.7884Z"
          fill="url(#paint1_linear_16678_514)"
        />
        <path
          d="M27.2428 21.539C26.8806 20.7339 26.4995 20.7178 26.155 20.7036C25.8731 20.6916 25.5507 20.6924 25.2286 20.6924C24.9062 20.6924 24.3824 20.8136 23.9396 21.2972C23.4963 21.781 22.2474 22.9504 22.2474 25.3287C22.2474 27.7073 23.9799 30.0056 24.2213 30.3284C24.4631 30.6507 27.5657 35.6876 32.4792 37.6253C36.5629 39.2356 37.3939 38.9153 38.2802 38.8346C39.1665 38.7541 41.1404 37.6656 41.5431 36.5367C41.946 35.408 41.946 34.4405 41.8252 34.2384C41.7044 34.0369 41.382 33.916 40.8986 33.6744C40.415 33.4326 38.0384 32.263 37.5954 32.1016C37.1521 31.9405 36.8299 31.86 36.5074 32.344C36.1851 32.8274 35.2593 33.916 34.9772 34.2384C34.6953 34.5615 34.4131 34.6018 33.9297 34.36C33.4462 34.1174 31.8892 33.6075 30.0422 31.9608C28.605 30.6794 27.6349 29.0971 27.3528 28.6131C27.0709 28.1297 27.3227 27.8678 27.5651 27.6268C27.7823 27.4102 28.0487 27.0624 28.2904 26.7803C28.5316 26.4979 28.6121 26.2965 28.7732 25.974C28.9346 25.6514 28.8539 25.3691 28.7331 25.1273C28.6121 24.8855 27.6727 22.4949 27.2428 21.539Z"
          fill="white"
        />
      </g>

      <defs>
        <linearGradient
          id="paint0_linear_16678_514"
          x1="1888.8"
          y1="3778.98"
          x2="1888.8"
          y2="10.9627"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#219335" />
          <stop offset="1" stopColor="#5AC963" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_16678_514"
          x1="1955.43"
          y1="3913.41"
          x2="1955.43"
          y2="10.2791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9F9F9" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_16678_514">
          <rect
            width="38.8571"
            height="39.1607"
            fill="white"
            transform="translate(12.5706 10.2852)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default BookViaWhatsAppIcon
